export default (err: any) => {
  if (err && err.response && err.response.status === 401) {
    window.location.href = `${process.env.BASE_URL}logout`;
  } else {
    return Promise.reject(err);
  }
};
